import { createContext } from 'react';
type CourseContextPayload = {
	triggerUpdate: Function;
	id?: number;
};

export const CourseContext = createContext<CourseContextPayload>({
	triggerUpdate: () => {},
});
